<template>
    <div>
        <bc-circle-loader v-if="loading == true"></bc-circle-loader>
        <v-container v-else fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ order.order_id ? $t("lang.edit_order") : $t("lang.add_order") }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh v-if="order.order_id && order.order_id > 0" @invoke-method="dbGetOrder(true)"></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="order.order_id && order.order_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print Order </v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="current_user.slug != 'customer'" @click="setEmailDialog()">
                                    <v-list-tile-title>Email Order</v-list-tile-title>
                                    <v-divider class="ml-3 my-0"></v-divider>
                                </v-list-tile>
                                <v-list-tile v-if="current_user.slug == 'employee' && order.status_id != 27" @click="approveOrder()">
                                    <v-list-tile-title>Approve Order</v-list-tile-title>
                                    <v-divider class="ml-3 my-0"></v-divider>
                                </v-list-tile>

                                <v-list-tile v-if="order.status_id != 169 && current_user.slug != 'customer'" @click="convertToInvoice()">
                                    <v-list-tile-title> Convert to Invoice </v-list-tile-title>
                                </v-list-tile>
                                <!--<template v-if="hasPerm('orders.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in order_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != order.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>-->
                                <!-- <v-divider class="ml-3 my-0"></v-divider> -->
                                <v-list-tile v-if="current_user.slug != 'customer'" @click="flipCurrency">
                                    <v-list-tile-title v-if="convert_currency">View as Company</v-list-tile-title>
                                    <v-list-tile-title v-else>View as Customer</v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('orders.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_order.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'orders' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-container fluid grid-list-xl :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <bc-transaction-links :items="order.transaction_links" :object_id="order.order_id"></bc-transaction-links>
                    <v-flex :class="order.order_id != null ? 'lg10 md9 xs12' : 'lg12 md12 xs12'" pb-0 mb-0>
                        <v-card elevation="0">
                            <v-card-text :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
                                <div v-if="order.status" class="ribbon ribbon-top-right" :class="`ribbon-${order.status_class}`">
                                    <span class="ribbon-span">{{ order.status }}</span>
                                </div>

                                <vue-perfect-scrollbar
                                    class="scroll-area"
                                    :style="$bp.xs ? null : 'max-height: calc(100vh - 260px); min-height: calc(100vh - 260px)'"
                                >
                                    <v-form ref="formOrder">
                                        <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                            <v-flex xs12 sm6 row-2-fr1>
                                                <v-flex xs12>
                                                    <bc-autocomplete
                                                        v-if="order.status_id != 169"
                                                        v-model="order.company_id"
                                                        :label="`${$t('lang.company_id')} *`"
                                                        :items="filter_customer_options"
                                                        item-value="company_id"
                                                        item-text="company"
                                                        :rules="ifValid('orders.company_id')"
                                                        @change="selectCustomer(order.company_id)"
                                                        :disabled="current_user.slug == 'customer' ? true : false"
                                                    ></bc-autocomplete>
                                                    <bc-autocomplete
                                                        v-else
                                                        v-model="order.company_id"
                                                        :label="`${$t('lang.company_id')} *`"
                                                        :items="filter_customer_options"
                                                        item-value="company_id"
                                                        item-text="company"
                                                        append-icon="lock"
                                                        disabled
                                                    ></bc-autocomplete>
                                                </v-flex>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <div
                                                            class="customer-address"
                                                            v-if="order.billing_address_id != null"
                                                            style="padding: 0px 12px 12px 12px"
                                                        >
                                                            <h3>
                                                                {{ $t("lang.billing_address_id") }}
                                                                <v-btn
                                                                    v-if="order.status_id != 169 && current_user.slug != 'customer'"
                                                                    color="secondary"
                                                                    icon
                                                                    small
                                                                    @mouseup.left="changeAddress('bill_address')"
                                                                >
                                                                    <v-icon small>edit</v-icon>
                                                                </v-btn>
                                                            </h3>
                                                            <div>
                                                                <div v-if="order.bill_location_label">
                                                                    {{ order.bill_location_label }}
                                                                </div>
                                                                <div>
                                                                    {{ order.bill_address1 }}
                                                                </div>
                                                                <div v-if="order.bill_address2 != ''">
                                                                    {{ order.bill_address2 }}
                                                                </div>
                                                                <div>
                                                                    {{ order.bill_city }}, {{ order.bill_state }},
                                                                    {{ order.bill_zip_code }}
                                                                </div>
                                                                <div>
                                                                    {{ order.bill_country_iso_3 }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <div
                                                            class="customer-address"
                                                            v-if="order.shipping_address_id != null"
                                                            style="padding: 0px 12px 12px 12px"
                                                        >
                                                            <h3>
                                                                {{ $t("lang.shipping_address_id") }}
                                                                <v-btn
                                                                    v-if="order.status_id != 169 && current_user.slug != 'customer'"
                                                                    color="secondary"
                                                                    icon
                                                                    small
                                                                    @mouseup.left="changeAddress('ship_address')"
                                                                >
                                                                    <v-icon small>edit</v-icon>
                                                                </v-btn>
                                                            </h3>
                                                            <div>
                                                                <div v-if="order.ship_location_label">
                                                                    {{ order.ship_location_label }}
                                                                </div>
                                                                <div>
                                                                    {{ order.ship_address1 }}
                                                                </div>
                                                                <div v-if="order.ship_address2 != ''">
                                                                    {{ order.ship_address2 }}
                                                                </div>
                                                                <div>
                                                                    {{ order.ship_city }}, {{ order.ship_state }},
                                                                    {{ order.ship_zip_code }}
                                                                </div>
                                                                <div>
                                                                    {{ order.ship_country_iso_3 }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 sm6>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        v-if="order.order_id"
                                                        v-model="order.order_id"
                                                        :label="$t('lang.order_id')"
                                                        :counter="showCounter(order.order_id, 'orders.order_id')"
                                                        :rules="ifValid('orders.order_id')"
                                                        disabled
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <bc-date-picker
                                                            v-model="order.order_date"
                                                            :label="$t('lang.order_date')"
                                                            :rules="ifValid('orders.order_date')"
                                                            :is_disabled="current_user.slug == 'customer' ? true : false"
                                                        ></bc-date-picker>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <bc-date-picker
                                                            v-model="order.ship_date"
                                                            :label="$t('lang.expected_ship_date')"
                                                            :rules="ifValid('orders.ship_date')"
                                                        ></bc-date-picker>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-model="order.payment_term_id"
                                                            :label="`${$t('lang.payment_term')} *`"
                                                            :items="filter_payment_terms"
                                                            item-value="payment_term_id"
                                                            item-text="description"
                                                            :rules="ifValid('orders.payment_term_id')"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-text-field
                                                            v-model="order.customer_po"
                                                            :label="$t('lang.customer_po')"
                                                            :rules="ifValid('orders.customer_po')"
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-model="order.shipping_carrier_id"
                                                            :label="$t('lang.shipping_carrier_id')"
                                                            :items="filter_shipping_carriers"
                                                            item-value="company_id"
                                                            item-text="company"
                                                            :rules="ifValid('orders.shipping_carrier_id')"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-model="order.freight_term_id"
                                                            :label="$t('lang.freight_term_id')"
                                                            :items="filter_freight_terms"
                                                            item-value="option_id"
                                                            item-text="option"
                                                            :rules="ifValid('orders.freight_term_id')"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout
                                                    row
                                                    wrap
                                                    :class="$bp.smallScreen ? 'mx-0' : null"
                                                    style="margin: 0px"
                                                    v-if="current_user.login_type_id != '2'"
                                                >
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-model="order.currency_id"
                                                            :label="$t('lang.document_currency')"
                                                            :items="filter_currencies"
                                                            item-value="currency_id"
                                                            item-text="name"
                                                            :rules="ifValid('orders.currency_id')"
                                                            @change="setExchangeRate(order.currency_id)"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-text-field
                                                            v-model="order.exchange_rate"
                                                            :label="$t('lang.exchange_rate')"
                                                            :counter="showCounter(order.exchange_rate, 'orders.exchange_rate')"
                                                            :rules="ifValid('orders.exchange_rate')"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs6>
                                                        <v-text-field
                                                            v-model="order.work_order_no"
                                                            :label="$t('lang.work_order_no')"
                                                            :rules="ifValid('orders.work_order_no')"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs6 v-if="current_user.login_type_id == '1'">
                                                        <bc-autocomplete
                                                            v-model="order.project_id"
                                                            :label="`${$t('lang.project')}`"
                                                            :items="projects"
                                                            item-value="project_id"
                                                            item-text="project_name"
                                                            :rules="ifValid('orders.project_id')"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <div>
                                            <v-data-table
                                                :headers="order_headers"
                                                :items="order.order_details || []"
                                                item-key="order_detail_id"
                                                :no-data-text="$t('lang.no_results_matching')"
                                                hide-actions
                                                class="custom-table"
                                            >
                                                <template slot="items" slot-scope="props">
                                                    <tr>
                                                        <td>
                                                            <!-- <bc-autocomplete
                                                                v-model="props.item.part_id"
                                                                :items="filter_fe_part_options(props.item)"
                                                                item-value="part_id"
                                                                item-text="sales_sku"
                                                                @change="handleChangePart(props.index, props.item.part_id)"
                                                                :rules="ifValid('orders.order_details.part_id')"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></bc-autocomplete> -->
                                                            <bc-autocomplete
                                                                v-if="props.item.part_id == null"
                                                                v-model="props.item.part_id"
                                                                :items="filter_fe_part_options(props.item)"
                                                                item-value="part_id"
                                                                item-text="sales_sku"
                                                                @change="handleChangePart(props.index, props.item.part_id)"
                                                                :rules="ifValid('orders.order_details.part_id')"
                                                                :append-icon="current_user.login_type_id != '1' ? 'lock' : 'arrow_drop_down'"
                                                                :disabled="current_user.login_type_id != '1' ? true : false"
                                                                :filter="$filterFePartsSales"
                                                                :ref="`${props.index}_order_detail_id`"
                                                            >
                                                                <template slot="item" slot-scope="data">
                                                                    <v-list-tile-content>
                                                                        <v-list-tile-title
                                                                            ><strong>{{ data.item.sales_sku }}</strong></v-list-tile-title
                                                                        >
                                                                        <v-list-tile-sub-title v-html="data.item.name"></v-list-tile-sub-title>
                                                                        <v-list-tile-sub-title v-html="data.item.model_number"></v-list-tile-sub-title>
                                                                    </v-list-tile-content>
                                                                </template>
                                                            </bc-autocomplete>
                                                            <v-list-tile v-else class="full-height-tile">
                                                                <v-list-tile-content>
                                                                    <v-list-tile-title
                                                                        ><strong>{{ props.item.sales_sku || props.item.sku }}</strong></v-list-tile-title
                                                                    >
                                                                    <v-list-tile-sub-title>{{ `Name: ${props.item.name}` }}</v-list-tile-sub-title>
                                                                    <v-list-tile-sub-title>{{ `Model: ${props.item.model_number}` }}</v-list-tile-sub-title>
                                                                </v-list-tile-content>
                                                                <v-list-tile-action style="position: absolute; top: 0px; right: 0px; align-items: normal">
                                                                    <v-btn icon ripple @click="resetLine(props.index, props.item)">
                                                                        <v-icon color="grey lighten-1">cancel</v-icon>
                                                                    </v-btn>
                                                                </v-list-tile-action>
                                                            </v-list-tile>
                                                        </td>
                                                        <td>
                                                            <v-text-field v-model="props.item.hts_code" disabled></v-text-field>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                v-model="props.item.quantity"
                                                                :counter="showCounter(props.item.quantity, 'orders.order_details.quantity')"
                                                                :rules="ifValid('orders.order_details.quantity')"
                                                                :ref="`${props.index}_quantity`"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></v-text-field>
                                                        </td>
                                                        <td>
                                                            <bc-autocomplete
                                                                v-model="props.item.sales_unit"
                                                                :items="filter_sales_units(props.item)"
                                                                item-value="option_id"
                                                                item-text="option"
                                                                :rules="ifValid('orders.order_details.sales_unit')"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></bc-autocomplete>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                v-model="props.item.lead_time"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></v-text-field>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                :prefix="
                                                                    convert_currency == true && order.currency_prefix != null ? order.currency_prefix : '$'
                                                                "
                                                                :suffix="convert_currency == true && order.currency_suffix != null ? order.currency_suffix : ''"
                                                                v-model="props.item.unit_price"
                                                                :counter="showCounter(props.item.unit_price, 'orders.order_details.unit_price')"
                                                                :rules="ifValid('orders.order_details.unit_price')"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></v-text-field>
                                                        </td>
                                                        <td style="display: flex">
                                                            <v-text-field
                                                                class="pr-3"
                                                                v-if="props.item.line_discount_type == 'P'"
                                                                v-model="props.item.line_discount_percentage"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></v-text-field>
                                                            <v-text-field
                                                                class="pr-3"
                                                                v-else-if="props.item.line_discount_type == 'A'"
                                                                v-model="props.item.line_discount_amount"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></v-text-field>
                                                            <v-btn
                                                                v-if="current_user.slug != 'customer'"
                                                                class="ma-0 pa-0"
                                                                x-small
                                                                raised
                                                                style="min-width: 25px !important"
                                                                @click="setDetailDiscount(props.index)"
                                                            >
                                                                {{
                                                                    convert_currency == true
                                                                        ? order.currency_prefix != null && props.item.line_discount_type == "A"
                                                                            ? order.currency_prefix
                                                                            : "%"
                                                                        : props.item.line_discount_type == "P"
                                                                        ? "%"
                                                                        : "$"
                                                                }}
                                                            </v-btn>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                :prefix="
                                                                    convert_currency == true && order.currency_prefix != null ? order.currency_prefix : '$'
                                                                "
                                                                :suffix="convert_currency == true && order.currency_suffix != null ? order.currency_suffix : ''"
                                                                v-model="props.item.line_total"
                                                                disabled
                                                            ></v-text-field>
                                                        </td>
                                                        <td v-if="order.status_id != 169 && current_user.slug != 'customer'">
                                                            <v-icon @click="removeRow(props.index)">delete</v-icon>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </div>

                                        <v-card class="mx-auto mb-4" elevation="0">
                                            <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                                                    <v-flex xs12 sm8>
                                                        <v-container fluid class="pa-0">
                                                            <v-btn
                                                                v-if="order.status_id != 169 && current_user.slug != 'customer'"
                                                                x-small
                                                                raised
                                                                color="primary"
                                                                @click="addRow()"
                                                                >{{ $t("lang.add_more") }}</v-btn
                                                            >
                                                        </v-container>
                                                    </v-flex>
                                                    <v-flex xs12 sm4>
                                                        <table style="width: 100%">
                                                            <tbody>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">
                                                                        {{ $t("lang.subtotal") }}
                                                                    </th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && order.currency_prefix != null
                                                                                    ? order.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && order.currency_suffix != null
                                                                                    ? order.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="order.subtotal"
                                                                            :counter="showCounter(order.subtotal, 'orders.subtotal')"
                                                                            :rules="ifValid('orders.subtotal')"
                                                                            disabled
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.discount") }}</th>
                                                                    <td>
                                                                        <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                                                                            <v-flex xs11 class="pr-3" :class="$bp.smallScreen ? 'pl-0' : null">
                                                                                <v-text-field
                                                                                    v-model="order.discount"
                                                                                    :counter="showCounter(order.discount, 'orders.discount')"
                                                                                    :rules="ifValid('orders.discount')"
                                                                                    :disabled="current_user.slug == 'customer' ? true : false"
                                                                                ></v-text-field>
                                                                            </v-flex>
                                                                            <v-flex xs1 class="pl-0">
                                                                                <v-container fluid class="pa-0">
                                                                                    <v-btn
                                                                                        v-if="current_user.slug != 'customer'"
                                                                                        class="ma-0 pa-0"
                                                                                        x-small
                                                                                        raised
                                                                                        style="min-width: 25px !important"
                                                                                        @click="setDiscount(order.discount_type)"
                                                                                    >
                                                                                        {{
                                                                                            convert_currency == true
                                                                                                ? order.currency_prefix != null && order.discount_type == "A"
                                                                                                    ? order.currency_prefix
                                                                                                    : "%"
                                                                                                : order.discount_type == "P"
                                                                                                ? "%"
                                                                                                : "$"
                                                                                        }}
                                                                                    </v-btn>
                                                                                </v-container>
                                                                            </v-flex>
                                                                        </v-layout>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.freight") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && order.currency_prefix != null
                                                                                    ? order.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && order.currency_suffix != null
                                                                                    ? order.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="order.freight"
                                                                            :counter="showCounter(order.freight, 'orders.freight')"
                                                                            :rules="ifValid('orders.freight')"
                                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.customs") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && order.currency_prefix != null
                                                                                    ? order.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && order.currency_suffix != null
                                                                                    ? order.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="order.customs"
                                                                            :counter="showCounter(order.customs, 'orders.customs')"
                                                                            :rules="ifValid('orders.customs')"
                                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.expedite_fee") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && order.currency_prefix != null
                                                                                    ? order.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && order.currency_suffix != null
                                                                                    ? order.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="order.expedite_fee"
                                                                            :counter="showCounter(order.expedite_fee, 'orders.expedite_fee')"
                                                                            :rules="ifValid('orders.expedite_fee')"
                                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.handling_charge") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && order.currency_prefix != null
                                                                                    ? order.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && order.currency_suffix != null
                                                                                    ? order.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="order.handling_charge"
                                                                            :counter="showCounter(order.handling_charge, 'orders.handling_charge')"
                                                                            :rules="ifValid('orders.handling_charge')"
                                                                            disabled
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.total_amount") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && order.currency_prefix != null
                                                                                    ? order.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && order.currency_suffix != null
                                                                                    ? order.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="order.total_amount"
                                                                            :counter="showCounter(order.total_amount, 'orders.total_amount')"
                                                                            :rules="ifValid('orders.total_amount')"
                                                                            disabled
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-text>
                                        </v-card>
                                        <v-flex xs12>
                                            <v-textarea
                                                v-model="order.comments"
                                                :label="$t('lang.comments')"
                                                auto-grow
                                                rows="1"
                                                :rules="ifValid('orders.comments')"
                                            ></v-textarea>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-autocomplete
                                                v-model="order.department_id"
                                                :label="$t('lang.department')"
                                                :items="department_options"
                                                item-value="department_id"
                                                item-text="department_name"
                                                :rules="ifValid('orders.department_id')"
                                                :disabled="current_user.slug == 'customer' ? true : false"
                                            ></bc-autocomplete>
                                        </v-flex>
                                    </v-form>
                                </vue-perfect-scrollbar>
                            </v-card-text>
                            <v-card-actions v-if="!convert_currency">
                                <v-spacer></v-spacer>
                                <v-btn v-if="order.status_id != 169" @mouseup.left="$router.push({ name: 'orders' })" flat>{{ $t("lang.cancel") }}</v-btn>
                                <v-btn v-if="order.status_id != 169 && current_user.slug != 'customer'" color="success" @click="saveOrders">{{
                                    $t("lang.save")
                                }}</v-btn>
                            </v-card-actions>
                            <v-card-actions v-else-if="convert_currency && current_user.slug != 'customer'" style="width: 100%" class="pa-0">
                                <v-alert style="width: 100%; padding: 12px !important" :value="true" type="warning" color="#f78c00">{{
                                    $t("lang.warn_viewing_as_customer")
                                }}</v-alert>
                            </v-card-actions>
                            <v-card-actions v-else style="width: 100%" class="pa-0">
                                <v-spacer></v-spacer>
                                <v-btn v-if="order.status_id != 170" @mouseup.left="$router.push({ name: 'orders' })" flat>{{ $t("lang.cancel") }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>

            <bc-modal-email ref="emailDialog" :pdfReportName="`order_${order.order_id}.pdf`" :endPoint="`/orders/${order.order_id}/email`"></bc-modal-email>

            <bc-address-selector ref="select_address_dialog" @eventname="updateAddress"></bc-address-selector>
            <delete-confirmation-dialog
                ref="delete_order"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_order')"
                :message="$t('lang.delete_order_confirm')"
                @onConfirm="deleteOrders()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_order_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteOrderDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import axios from "axios";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],
            order_headers: [
                { text: this.$t("lang.part_id"), sortable: false, width: "25%" },
                { text: this.$t("lang.hts_code"), sortable: false, width: "5%" },
                { text: this.$t("lang.quantity"), sortable: false, width: "5%" },
                { text: this.$t("lang.sales_unit"), sortable: false, width: "10%" },
                { text: this.$t("lang.lead_time"), sortable: false, width: "5%" },
                // { text: this.$t("lang.cost_price"), sortable: false, width: "10%" },
                { text: this.$t("lang.unit_price"), sortable: false, width: "10%" },
                { text: this.$t("lang.discount"), sortable: false, width: "10%" },
                { text: this.$t("lang.line_total"), sortable: false, width: "10%" },
                { text: "", width: "3%", sortable: false },
            ],
            formData: {},
            order: {
                expedite_fee: "0.000",
                handling_charge: "0.000",
                freight: "0.000",
                customs: "0.000",
                subtotal: "0.000",
                discount: "0.000",
                total_amount: "0.000",
                discount_type: "A",
                order_details: [],
                billing_address_id: null,
                shipping_address_id: null,
                bill_address: null,
                ship_address: null,
                address_options: [],
                currency_id: "1",
                exchange_rate: "1.000000",
                currency_prefix: "$",
                currency_suffix: "",
                currency_precision: 3,
            },
            file_name: "",
            dbGetOrder: _.debounce(this.refresh, 1500, { maxWait: 1500, leading: true, trailing: false }),
            email_dialog: false,
            convert_currency: false,
            loading: true,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchOrder", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.order) {
                        this.order = this.assignObj2(data.order, this.rules_orders);
                        if (this.current_user.login_type_id == "2") this.flipCurrency();
                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=order_status&sort_by=2",
                            method: "get",
                            stateProperty: "order_status_options",
                            dataProperty: "options",
                            commit: true,
                        });
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "orders", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchOrder", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.order) {
                        next((vm) => {
                            vm.order = vm.assignObj2(data.order, vm.rules_orders);
                            if (vm.current_user.login_type_id == "2") vm.flipCurrency();
                            store.dispatch("fetchSetting", {
                                url: "options?slug=order_status&sort_by=2",
                                method: "get",
                                stateProperty: "order_status_options",
                                dataProperty: "options",
                                commit: true,
                            });
                            vm.$store.commit("toggleMainMenu", false);
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "orders", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("resetOptions");
        this.$store.commit("resetPeople");
        this.$store.commit("resetCustomers");
        this.$store.commit("resetCurrencies");
        this.$store.commit("resetFeParts");
        this.$store.commit("resetPaymentTerms");
        this.$store.commit("resetDepartments");
        this.$store.commit("resetShippingCarriers");
        this.$store.commit("resetProjects");
        next();
    },
    computed: {
        ...mapState({
            rules_orders: (state) => state.orders.rules_orders,
            order_status_options: (state) => state.settings.order_status_options,
            orders: (state) => state.orders.orders,
            selectedOrder: (state) => state.orders.selectedOrder,
            fe_part_options: (state) => state.fe_parts.fe_part_options,
            shipping_carriers: (state) => state.shipping_carriers.shipping_carrier_options,
            sales_units: (state) => state.options_categories.sales_units,
            order_status: (state) => state.options_categories.order_status,
            freight_terms: (state) => state.options_categories.freight_terms,
            customer_options: (state) => state.customers.customer_options,
            department_options: (state) => state.departments.department_options,
            payment_terms: (state) => state.payment_terms.payment_term_options,
            currencies: (state) => state.currencies.currencies,
            projects: (state) => state.projects.project_options,
        }),
        filter_customer_options() {
            return this.customer_options.filter((record) => !record.date_deleted || record.company_id === this.order.company_id);
        },
        filter_freight_terms() {
            return this.freight_terms.filter((record) => !record.date_deleted || record.option_id === this.order.freight_term_id);
        },
        filter_shipping_carriers() {
            return this.shipping_carriers.filter((record) => !record.date_deleted || record.company_id === this.order.shipping_carrier_id);
        },
        filter_currencies() {
            return this.currencies.filter((record) => !record.date_deleted || record.currency_id === this.order.currency_id);
        },
        filter_fe_part_options: function () {
            return function (item) {
                return this.fe_part_options.filter((record) => !record.date_deleted || record.part_id === item.part_id);
            };
        },
        filter_sales_units: function () {
            return function (item) {
                return this.sales_units.filter((record) => !record.date_deleted || record.option_id === item.sales_unit);
            };
        },
        filter_payment_terms() {
            return this.payment_terms.filter((record) => !record.date_deleted || record.option_id === this.order.payment_term_id);
        },
        filter_department_options() {
            return this.department_options.filter((record) => !record.date_deleted || record.option_id === this.order.department_option_id);
        },
    },
    watch: {
        order: {
            handler: function (newValue) {
                if (!newValue.order_details) newValue.order_details = [];

                let subtotal = 0;
                for (let p of newValue.order_details) {
                    if (p.line_discount_type == "A") {
                        p.line_total = (p.unit_price * p.quantity - p.line_discount_amount).toFixed(this.order.currency_precision);
                        subtotal += parseFloat(p.line_total);
                    } else {
                        p.line_total = (p.unit_price * p.quantity - (p.unit_price * p.quantity * p.line_discount_percentage) / 100).toFixed(
                            this.order.currency_precision
                        );
                        subtotal += parseFloat(p.line_total);
                    }
                }
                newValue.subtotal = subtotal.toFixed(this.order.currency_precision);
                let total = subtotal;
                let discount = newValue.discount_type == "A" ? total - newValue.discount : total - (total * newValue.discount) / 100;
                total =
                    parseFloat(discount) +
                    parseFloat(newValue.expedite_fee) +
                    parseFloat(newValue.handling_charge) +
                    parseFloat(newValue.freight) +
                    parseFloat(newValue.customs);
                newValue.total_amount = total.toFixed(this.order.currency_precision);
            },
            deep: true,
        },
    },
    methods: {
        ...mapActions([
            "fetchOrder",
            "saveOrder",
            "deleteOrder",
            "printOrder",
            "fetchFeParts",
            "convertOrderToInvoice",
            "fetchPaymentTerms",
            "fetchCurrencies",
            "fetchShippingCarriers",
            "fetchCustomers",
            "fetchOptions",
            "fetchFreightTerms",
            "fetchDepartments",
            "fetchProjects",
            "fetchFePart",
            "fetchCustomer",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        addRow() {
            if (!this.order.order_details) this.order.order_details = [];
            this.order.order_details.push({
                order_id: `${this.$route.params.id}`,
                quantity: "1",
                sales_unit: "",
                model_number: "",
                name: "",
                line_discount_type: "P",
                line_discount_amount: "0.000",
                line_discount_percentage: "0.000",
                unit_price: "0.000",
            });
        },
        removeRow: function (index) {
            this.order.order_details.splice(index, 1);
        },
        changeAddress(type) {
            let address_list = this.order.address_options ? this.order.address_options : this.company.entity_addresses || [];
            this.$refs.select_address_dialog.showAddresses(address_list, type);
        },
        flipCurrency() {
            this.convert_currency = !this.convert_currency ? true : false;

            for (let p of this.order.order_details) {
                // if convert_currency is true, then convert the discount amount to the customer currency
                // calc cost_price, unit_price, line_discount_amount if amount
                if (this.convert_currency) {
                    p.cost_price = (p.cost_price * this.order.exchange_rate).toFixed(this.order.currency_precision);
                    p.unit_price = (p.unit_price * this.order.exchange_rate).toFixed(this.order.currency_precision);
                    if (p.line_discount_type == "A")
                        p.line_discount_amount = (p.line_discount_amount * this.order.exchange_rate).toFixed(this.order.currency_precision);
                } else {
                    p.cost_price = (p.cost_price / this.order.exchange_rate).toFixed(this.order.currency_precision);
                    p.unit_price = (p.unit_price / this.order.exchange_rate).toFixed(this.order.currency_precision);
                    if (p.line_discount_type == "A")
                        p.line_discount_amount = (p.line_discount_amount / this.order.exchange_rate).toFixed(this.order.currency_precision);
                }
            }
            // calc discount if amount, freight, customs, handling_charge, expedite_fee
            if (this.convert_currency) {
                if (this.order.discount_type == "A")
                    this.order.discount = (this.order.discount * this.order.exchange_rate).toFixed(this.order.currency_precision);
                this.order.freight = (this.order.freight * this.order.exchange_rate).toFixed(this.order.currency_precision);
                this.order.customs = (this.order.customs * this.order.exchange_rate).toFixed(this.order.currency_precision);
                this.order.expedite_fee = (this.order.expedite_fee * this.order.exchange_rate).toFixed(this.order.currency_precision);
                this.order.handling_charge = (this.order.handling_charge * this.order.exchange_rate).toFixed(this.order.currency_precision);
            } else {
                if (this.order.discount_type == "A")
                    this.order.discount = (this.order.discount / this.order.exchange_rate).toFixed(this.order.currency_precision);
                this.order.freight = (this.order.freight / this.order.exchange_rate).toFixed(this.order.currency_precision);
                this.order.customs = (this.order.customs / this.order.exchange_rate).toFixed(this.order.currency_precision);
                this.order.expedite_fee = (this.order.expedite_fee / this.order.exchange_rate).toFixed(this.order.currency_precision);
                this.order.handling_charge = (this.order.handling_charge / this.order.exchange_rate).toFixed(this.order.currency_precision);
            }
        },
        updateAddress(item, type) {
            if (type == "bill_address") {
                this.order.billing_address_id = item.entity_addresses_id;
                this.order.bill_location_label = item.location_label;
                this.order.bill_address1 = item.address1;
                this.order.bill_address2 = item.address2;
                this.order.bill_city = item.city;
                this.order.bill_state = item.state;
                this.order.bill_zip_code = item.zip_code;
                this.order.bill_zip_code_ext = item.zip_code_ext;
                this.order.bill_country_iso_3 = item.country_iso_3;
            } else if (type == "ship_address") {
                this.order.shipping_address_id = item.entity_addresses_id;
                this.order.ship_location_label = item.location_label;
                this.order.ship_address1 = item.address1;
                this.order.ship_address2 = item.address2;
                this.order.ship_city = item.city;
                this.order.ship_state = item.state;
                this.order.ship_zip_code = item.zip_code;
                this.order.ship_zip_code_ext = item.zip_code_ext;
                this.order.ship_country_iso_3 = item.country_iso_3;
            }
        },
        getOrder(pg_refresh = false) {
            this.startLoader();

            this.fetchOrder({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.order) {
                    this.order = this.assignObj2(data.order, this.rules_orders);
                    this.convert_currency = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printOrder({
                id: `${this.$route.params.id}`,
                view_as: this.convert_currency,
            }).then((data) => {
                if (typeof data != "undefined" && data.order) {
                    if (this.dev_mode) {
                        this.file_name = data.order.file_name;
                    } else {
                        this.$refs.print.printReport(data.order.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveOrders() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formOrder")) {
                    let body = this.prepForm(this.order, this.rules_orders);

                    this.saveOrder({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.order) {
                            this.$router.push({ name: "order", params: { id: data.order.order_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { order_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveOrder({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.order) {
                    this.order = this.assignObj2(data.order, this.rules_orders);
                    this.convert_currency = false;
                }
            });
        },
        deleteOrders() {
            this.deleteOrder({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.$refs.delete_order_details.close();
                    this.validationOff();
                    this.$router.push({ name: "orders" });
                }
                this.toggleModalLoader(false);
            });
        },
        convertToInvoice() {
            this.status_loader = true;
            let body = { order_id: `${this.$route.params.id}` };

            this.convertOrderToInvoice({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.fe_invoice) {
                    this.$router.push({ name: "fe_invoice", params: { id: data.fe_invoice.invoice_id } });
                }
            });
        },
        selectCustomer(company_id) {
            if (company_id == null) {
                return;
            } else {
                this.fetchCustomer({ id: company_id }).then((data) => {
                    if (data.customer) {
                        this.company = data.customer;

                        this.order.currency_id = this.company.currency_id ? this.company.currency_id : 1;
                        this.order.exchange_rate = this.company.exchange_rate ? this.company.exchange_rate : "1.000";

                        this.order.address_options = this.company.entity_addresses ? this.company.entity_addresses : [];
                        let ship_address = this.company.entity_addresses ? this.company.entity_addresses.filter((x) => x.address_type == "shipping")[0] : null;
                        this.order.ship_location_label = ship_address && ship_address.location_label ? ship_address.location_label : null;
                        this.order.shipping_address_id = ship_address && ship_address.entity_addresses_id ? ship_address.entity_addresses_id : null;
                        this.order.ship_address1 = ship_address && ship_address.address1 ? ship_address.address1 : null;
                        this.order.ship_address2 = ship_address && ship_address.address2 ? ship_address.address2 : null;
                        this.order.ship_city = ship_address && ship_address.city ? ship_address.city : null;
                        this.order.ship_state = ship_address && ship_address.state ? ship_address.state : null;
                        this.order.ship_zip_code = ship_address && ship_address.zip_code ? ship_address.zip_code : null;
                        this.order.ship_zip_code_ext = ship_address && ship_address.zip_code_ext ? ship_address.zip_code_ext : null;
                        this.order.ship_country_iso_3 = ship_address && ship_address.country_iso_3 ? ship_address.country_iso_3 : null;

                        let bill_address = this.company.entity_addresses ? this.company.entity_addresses.filter((x) => x.address_type == "billing")[0] : null;
                        this.order.bill_location_label = bill_address && bill_address.location_label ? bill_address.location_label : null;
                        this.order.billing_address_id = bill_address && bill_address.entity_addresses_id ? bill_address.entity_addresses_id : null;
                        this.order.bill_address1 = bill_address && bill_address.address1 ? bill_address.address1 : null;
                        this.order.bill_address2 = bill_address && bill_address.address2 ? bill_address.address2 : null;
                        this.order.bill_city = bill_address && bill_address.city ? bill_address.city : null;
                        this.order.bill_state = bill_address && bill_address.state ? bill_address.state : null;
                        this.order.bill_zip_code = bill_address && bill_address.zip_code ? bill_address.zip_code : null;
                        this.order.bill_zip_code_ext = bill_address && bill_address.zip_code_ext ? bill_address.zip_code_ext : null;
                        this.order.bill_country_iso_3 = bill_address && bill_address.country_iso_3 ? bill_address.country_iso_3 : null;
                    } else {
                        return;
                    }
                });
            }
        },

        setDetailDiscount(index) {
            let part = this.order.order_details[index];
            if (part.line_discount_type == "P") {
                part.line_discount_type = "A";
                part.line_discount_amount = part.line_discount_percentage;
                part.line_discount_percentage = "0.000";
            } else {
                part.line_discount_type = "P";
                part.line_discount_percentage = part.line_discount_amount;
                part.line_discount_amount = "0.000";
            }
        },
        setDiscount() {
            if (this.order.discount_type == "P" || this.order.discount_type == "%") {
                this.order.discount_type = "A";
            } else {
                this.order.discount_type = "P";
            }
        },
        handleChangePart(index, part_id) {
            // Get the part from the fe_part_options array based on the part_id
            let partObj = this.fe_part_options.find((x) => x.part_id == part_id);
            this.fetchFePart({ id: partObj.part_id }).then((data) => {
                if (typeof data !== "undefined" && data.fe_part) {
                    partObj = data.fe_part;
                    this.order.order_details[index].cost_price = partObj.part_cost;
                    this.order.order_details[index].unit_price = partObj.sales_price;
                    this.order.order_details[index].model_number = partObj.model_number;
                    this.order.order_details[index].sales_unit = partObj.sales_unit;
                    this.order.order_details[index].name = partObj.name;
                    this.order.order_details[index].lead_time = partObj.lead_time;
                    this.order.order_details[index].hts_code = partObj.hts_code;
                    this.order.order_details[index].sales_sku = partObj.sales_sku;

                    this.$refs[`${index}_quantity`].$el.querySelector("input").focus();
                }
            });
        },
        resetLine(index, item) {
            this.order.order_details[index].part_id = null;
            this.order.order_details[index].cost_price = null;
            this.order.order_details[index].unit_price = null;
            this.order.order_details[index].model_number = null;
            this.order.order_details[index].sales_unit = null;
            this.order.order_details[index].name = null;
            this.order.order_details[index].lead_time = null;
            this.order.order_details[index].hts_code = null;
            this.order.order_details[index].sales_sku = null;

            this.$nextTick(() => {
                this.$refs[`${index}_order_detail_id`].$children[0].focus();
                this.$refs[`${index}_order_detail_id`].$children[0].isMenuActive = true;
            });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchOrder({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.order) {
                        this.order = this.assignObj2(data.order, this.rules_orders);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            }

            //if (this.customer_options.length == 0 || force == true)
            this.fetchCustomers({ body: { options: 1, with_trashed: this.order.order_id ? "1" : "0" } });

            if (this.currencies.length == 0 || force == true) this.fetchCurrencies({ body: { options: 1, with_trashed: this.order.order_id ? "1" : "0" } });
            //if (this.fe_part_options.length == 0 || force == true)
            this.fetchFeParts({ body: { options: 1, with_trashed: this.order.order_id ? "1" : "0" } });

            if (this.order.order_date == null || force == true) this.order.order_date = new Date().toISOString().slice(0, 10);

            if (this.freight_terms == 0 || force == true)
                this.fetchOptions({ body: { slug: "freight_terms", with_trashed: this.order.order_id ? "1" : "0", options: 1 } });
            if (this.order_status == 0 || force == true)
                this.fetchOptions({ body: { slug: "order_status", with_trashed: this.order.order_id ? "1" : "0", options: 1 } });
            if (this.sales_units == 0 || force == true)
                this.fetchOptions({ body: { slug: "sales_units", sort_by: "0", with_trashed: this.order.order_id ? "1" : "0", options: 1 } });
            if (this.department_options.length == 0 || force == true)
                this.fetchDepartments({ body: { options: 1, with_trashed: this.order.order_id ? "1" : "0" } });

            if (!this.order.department_id) this.order.department_id = this.currUserField("department_id");
            if (this.payment_terms.length == 0 || force == true)
                this.fetchPaymentTerms({ body: { options: 1, with_trashed: this.order.order_id ? "1" : "0" } });

            if (this.shipping_carriers.length == 0 || force == true)
                this.fetchShippingCarriers({ body: { options: 1, with_trashed: this.order.order_id ? "1" : "0", department_id: "1" } });

            if (this.order.status_id == 169) {
                this.order_headers.pop();
            } else {
                this.order_headers = [
                    { text: this.$t("lang.part_id"), sortable: false, width: "25%" },
                    { text: this.$t("lang.hts_code"), sortable: false, width: "5%" },
                    { text: this.$t("lang.quantity"), sortable: false, width: "5%" },
                    { text: this.$t("lang.sales_unit"), sortable: false, width: "10%" },
                    { text: this.$t("lang.lead_time"), sortable: false, width: "5%" },
                    // { text: this.$t("lang.cost_price"), sortable: false, width: "10%" },
                    { text: this.$t("lang.unit_price"), sortable: false, width: "10%" },
                    { text: this.$t("lang.discount"), sortable: false, width: "10%" },
                    { text: this.$t("lang.line_total"), sortable: false, width: "10%" },
                    { text: "", width: "3%", sortable: false },
                ];
            }

            if (this.projects.length == 0 || force == true) await this.fetchProjects({ body: { options: 1 } });

            this.loading = false;
            this.finishLoader();
        },

        setExchangeRate(currency_id) {
            let exchange_rate = this.currencies.find((x) => x.currency_id == currency_id);
            this.order.currency_id = exchange_rate.currency_id;
            this.order.exchange_rate = exchange_rate.exchange_rate ? exchange_rate.exchange_rate : "1.000000";
        },
        setEmailDialog() {
            this.validationOff();
            this.$refs.emailDialog.showEmail();
        },
        approveOrder() {
            this.order.status_id = 27;
            this.saveOrders();
        },
    },
};
</script>
<style lang="css">
.custom-table .v-table tbody tr td {
    vertical-align: top !important;
}
</style>
